import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import './SubjectiveFeelings.scss';
import { useState } from 'react';
import { HelpOutline } from '@mui/icons-material';
import { useRecoilValue } from 'recoil';
import { selectedDateAtom, usePhaseEmaTimeline } from '../../../../../../data-access';
import { useGeneralSettings } from '../../../../../../hooks/useGeneralSettings';
import { formatTime } from '../../../../../../helpers/time.helper';
import PhaseAccordionItem from './PhaseAccordionItem';
import { CircadianPhase } from '@demind-inc/core';
import { CustomTooltip, CustomTooltipContent } from '../../../../../common';
import { subjectiveFeelingsTooltipInfo } from '../../../../constants';
import { useTranslation } from 'react-i18next';

const SubjectiveFeelings: FC = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<CircadianPhase | false>(false);
  const {
    generalSettings: { timeFormat },
  } = useGeneralSettings();
  const selectedDate = useRecoilValue(selectedDateAtom);
  const { phaseEmaTimeline, handleUpdatePhaseEma } = usePhaseEmaTimeline({
    date: selectedDate.format('YYYY-MM-DD'),
  });

  const timeFormatString = formatTime(timeFormat);
  const localizedTooltipInfo = {
    ...subjectiveFeelingsTooltipInfo,
    title: t('data.satisfaction.subjectiveEnergy'),
    description: t('data.satisfaction.subjectiveEnergyTooltipDescription'),
  };

  return (
    <Stack direction="column" gap={2} className="subjective-feelings">
      <Stack direction="row" gap={0.5} alignItems="center" mb={2}>
        <Typography variant="h6" className="subjective-feelings__title">
          {t('data.satisfaction.subjectiveEnergy')}
        </Typography>
        <CustomTooltip
          title={<CustomTooltipContent {...localizedTooltipInfo} />}
          className="peak-energy__tooltip"
        >
          <HelpOutline fontSize="small" />
        </CustomTooltip>
      </Stack>

      <Stack gap={1} className="subjective-feelings__accordion-list">
        {phaseEmaTimeline.map((phaseData) => (
          <PhaseAccordionItem
            key={phaseData.phase}
            phaseData={phaseData}
            expanded={expanded}
            onExpandedChange={setExpanded}
            timeFormatString={timeFormatString}
            handleUpdatePhaseEma={handleUpdatePhaseEma}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default SubjectiveFeelings;
